import React from 'react'
import { getSizedImageUrl } from '../../../../../scripts/utils/image';
import { ISearchAndFilterProduct } from '../../../../context/search/types'
import Price from '../../../Price';


interface ISearchResultsProductItemComponent {
  product: ISearchAndFilterProduct
}

const SearchResultsProductItem: React.FC<ISearchResultsProductItemComponent> = ({product}): JSX.Element => {
  return (
    <a href={product.url} className="sf-results-product">
      <div className="sf-results-product-image">
        { product.images && product.images.length > 0 && (
          <img
            loading="lazy"
            height="300"
            width="240"
            alt={product.images[0].alt}
            src={getSizedImageUrl(product.images[0].src, '240x300_crop_center')} />)
        }
      </div>
      <div className="sf-results-product-details">
        <h6>{product.name}</h6>
        <Price
          finalPrice={product.price.finalPrice}
          originalPrice={product.price.originalPrice}
          priceMin={product.price.priceMin}
          priceMax={product.price.priceMax}
          priceVaries={product.price.priceMin !== product.price.priceMax}
        />
      </div>
    </a>
  )
}

export default SearchResultsProductItem